<template>
    <div class="relative flex h-full flex-col">
        <Head :title="$page.props.title" />

        <Header :is-subdomain="isSubdomain" />

        <main class="flex-1 pt-24 lg:pt-[8.25rem]">
            <slot></slot>
        </main>

        <Footer v-show="!isSubdomain" />

        <CookieConsent />
    </div>
</template>

<script setup>
    import Header from '@/Shared/Header';
    import Footer from '@/Shared/Footer';
    import CookieConsent from '@/Partials/CookieConsent';

    const props = defineProps({
        isSubdomain: {
            type: Boolean,
            default: false,
        },
    });
</script>
